export const MuiTab = {
    styleOverrides: {
        root: { fontSize: "14px", fontWeight: 600, minWidth: "32px", borderBottom: "1px solid rgba(0, 83, 229, 0.12)" }
    }
};
//# sourceMappingURL=Tab.js.map